module.exports = __webpack_public_path__ + "static/images/cover_D1.9c9ea69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_D1.png
// module id = dXXo
// module chunks = 8